var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tile is-ancestor is-parent" }, [
    _c("div", { staticClass: "tile is-parent" }, [
      _c("article", { staticClass: "tile is-child p-4" }, [
        _c("div", [
          _vm.isLoading > 0
            ? _c("div", { staticClass: "section" }, [
                _c("span", {
                  staticClass:
                    "is-loading-image has-text-grey has-text-centered",
                }),
              ])
            : _c(
                "div",
                _vm._l(_vm.categoryAttachments, function (category) {
                  return _c(
                    "div",
                    {
                      key: category.quoteAttachmentCategoryId,
                      staticStyle: { "margin-bottom": "1em" },
                    },
                    [
                      _c("h6", { staticClass: "title is-6" }, [
                        _vm._v(_vm._s(category.name)),
                      ]),
                      _c(
                        "div",
                        { staticClass: "columns is-multiline" },
                        _vm._l(category.attachments, function (attachment) {
                          return _c(
                            "div",
                            {
                              key: attachment.quoteAttachmentId,
                              staticClass: "column is-1 m-0 p-1",
                            },
                            [
                              _c("quote-attachment", {
                                attrs: {
                                  attachment: attachment,
                                  "quote-id": _vm.quoteId,
                                  "quote-attachment-id":
                                    attachment.quoteAttachmentId,
                                  "quote-attachment-category-id":
                                    category.quoteAttachmentCategoryId,
                                  categories: _vm.categories,
                                },
                                on: {
                                  "update:attachment": _vm.onUpdateAttachment,
                                },
                              }),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ]
                  )
                }),
                0
              ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }